
// Password form fields - toggle password visibility
$('form input[type="password"]').siblings('.show-password').click(function() {
  if ($(this).hasClass('hide-password')) {
    $(this).siblings('input').attr('type', 'password');
    $(this).removeClass('hide-password');
  } else {
    $(this).siblings('input').attr('type', 'text');
    $(this).addClass('hide-password');
  }
});
